export default __webpack_public_path__ + "static/media/Lightning Pick.184170de.png";